import React from "react";
import { Button, Checkbox, Input, Layout, PageHeader, Select, Spin } from "antd";
import InvalidList from './InvalidList'
import List from './List'
import users from "@services/users";

export default class AddClientGroup extends React.Component {

    constructor(props){
        super(props)
        this.state = {
            agentIdInput: '',
            selectedAgent: {},
            agentList: [],
            createCommissions: false,
            raw: '',
            deletedItems: {},
            notValid: [],
            errorUsers: [],
            successUsers: [],
            errorCounts: {},
            step: 1,
            loadingInvalid: false,
            showDeleteAll: false
        }
    }

    componentDidMount() {
        this.getAgents()
    }

    agentInput = (e) => {
        let value = e.target.value.replace(/[^0-9\.]/g, '')
        this.setState({ agentIdInput: value })
    }

    getAgents = () => {
        users.getAllAgents({ slug: 'agent' })
        .then((res) => {
            this.setState({ agentList: res.data })
        })
    }

    selectAgent = (value) => {
        let selectedAgent = this.state.agentList.find(({ id }) => id === value)
        this.setState({ selectedAgent })
    }

    addId = (json) => {
        json = JSON.parse(json)

        json.forEach((user, idx) => {
            user.tempId = idx + 1
        })

        return JSON.stringify(json)
    }

    validate = (e) => {
        e.preventDefault()
        let data = this.addId(e.target[0].value)
        this.setState({ loadingInvalid: true, raw: data }, () => this.sendValidation(data))
    }

    sendValidation = (data) => {
        users.validateUserGroup({ array: data })
        .then((res) => {            
            this.setState({
                notValid: res.data,
                step: 2,
                loadingInvalid: false
            })
        })
        .catch(() => {
            alert('אירעה שגיאה בעת אימות הנתונים')
            this.setState({ loadingInvalid: false })
        })
    }

    updateList = (user) => {        
        
        let list = [...this.state.notValid]
        
        let foundIndex = list.findIndex(({ tempId }) => tempId === user.tempId)
        list[foundIndex] = user
        this.setState({ notValid: list })
    }

    deleteItem = (id) => {
        let list = [...this.state.notValid]
        let foundIndex = list.findIndex(({ tempId }) => tempId === id)
        list.splice(foundIndex, 1)
        this.setState({ notValid: list, deletedItems: { ...this.state.deletedItems, [id]: id } })
    }

    deleteAll = () => {
        let deletedItems = {}
        this.state.notValid.forEach(({ tempId }) => deletedItems[tempId] = tempId);
        this.setState({ deletedItems, notValid: [], showDeleteAll: false })
    }

    sendUpdate = () => {
        
        const { selectedAgent: { id }, createCommissions, deletedItems } = this.state
    
        let notValidObj = {}
        let temp = JSON.parse(this.state.raw)
        let parsed = { array: temp }        
    
        if(this.state.notValid && this.state.notValid.length > 0) {
            this.state.notValid.forEach(el => {
                notValidObj[el.tempId] = el
            });                
        
            parsed.array.forEach((el, idx, array) => {
                if (notValidObj[el.tempId]) {
                        array[idx] = notValidObj[el.tempId]
                }
            });

        }
        parsed.array = parsed.array.filter(({ tempId }) => !deletedItems[tempId])
            
        parsed.agent_id = id 
        parsed.createCommissions = createCommissions
    
        users.addUserGroup(parsed)
        .then(({ data }) => {
                const { successUsers, errorUsers } = data
                    this.setState({ successUsers, errorUsers, step: 3 })
                    this.countErrors(errorUsers)
        })
    }

    countErrors = (users) => {
        let errorCounts = {}
        users.forEach((user) => {
            if (errorCounts[user.typeErr]) {
                errorCounts[user.typeErr]++
            } else {
                errorCounts[user.typeErr] = 1
            }
        })
        
        this.setState({ errorCounts })
    }

    render(){

        const {
            step,
            selectedAgent
            agentList,
            createCommissions,
            errorCounts,
            loadingInvalid,
            showDeleteAll
        } = this.state

        const showInvalidList = step === 2 && !loadingInvalid
        const showErrorUsersList = step === 3
        const showSuccessUsersList = step === 3        

        return (
            <Layout style={{ paddingInline: '35px' }}>
                 <PageHeader
                    onBack={() => window.history.back()}
                    title="הוספת קבוצת לקוחות"
                />

                <Layout.Content>

                    <div style={{ marginBottom: '100px' }}>
                        <div style={{ ...style.topRow }}>
                            <div style={{ ...style.searchAgent }}>

                                <div>
                                    <h6>{"חיפוש סוכן"}</h6>
                                    <Select
                                        showSearch
                                        //onSearch={this.searchAgent}
                                        onChange={this.selectAgent}
                                        style={{ width: '60%' }}
                                        defaultValue={'בחר/י סוכן'}
                                        value={selectedAgent.id}
                                        style={{ width: '250px' }}
                                    >
                                        {agentList.map((agent, index) => {
                                            return (
                                                <Select.Option key={index.toString()} value={agent.id}>
                                                    {`${agent.first_name} ${agent.last_name} - ${agent.id}`}
                                                </Select.Option>
                                            )
                                        })}
                                    </Select>
                                </div>
                                
                                <Button
                                    onClick={() => this.setState({ selectedAgent: {} })}
                                    style={{ marginBottom: '-1px' }}
                                >
                                    {"איפוס"}
                                </Button>

                            </div>


                            <Checkbox
                                onChange={() => this.setState({ createCommissions: !createCommissions })}
                                value={createCommissions}
                                style={{ marginBottom: '10px', marginLeft: 'auto', marginBottom: '0' }}
                            >
                                {"צור עמלות"}
                            </Checkbox>

                            
                            <Button>
                                <a target="_blank" href="https://products.aspose.app/cells/conversion/excel-to-json">{"ליצירת json"}</a>
                            </Button>

                        </div>

                        <div style={{ ...style.secondRow }}>
                            {selectedAgent.id &&
                                <>
                                    <span>{"הלקוחות ישוייכו לסוכן:"}</span>
                                    <div>
                                        <span>{selectedAgent.id}</span>
                                        <span>{` - ${selectedAgent.first_name} ${selectedAgent.last_name}`}</span>
                                    </div>
                                </>}
                        </div>

                        <div>
                            <h6>{"לקוחות חדשים:"}</h6>
                            <form onSubmit={this.validate}>
                                <Input.TextArea style={{ height: '300px', direction: 'ltr', textAlign: 'left' }} /*onChange={(e) => this.setState({ raw: e.target.value })}*/ />
                                <Button htmlType="submit" >{"validate"}</Button>
                            </form>
                        </div>

                        {showInvalidList &&
                            <div style={{ marginBottom: '30px' }}>
                                <InvalidList list={this.state.notValid} updateList={this.updateList} deleteItem={this.deleteItem} />
                                <div style={{ display:'flex', justifyContent: 'space-between' }}>
                                    <Button onClick={this.sendUpdate}>{"שמור שינויים"}</Button>
                                    <div>
                                        {!showDeleteAll &&
                                            <Button onClick={() => this.setState({ showDeleteAll: true })}>{"מחק הכל"}</Button>}
                                        {showDeleteAll &&
                                            <div>
                                                <Button onClick={this.deleteAll}>{"אישור"}</Button>
                                                <Button onClick={() => this.setState({ showDeleteAll: false })}>{"ביטול"}</Button>
                                            </div>}
                                    </div>
                                </div>
                            </div>}

                        {loadingInvalid &&
                            <div style={{ ...style.spinner }}>
                                <Spin size="large" />
                            </div>} 

                        {showErrorUsersList &&
                            <div style={{ marginTop: '30px', marginBottom: '30px' }}>
                                <h6>{"לא הוקמו / שגיאות:"}</h6>
                                <List users={this.state.errorUsers} type={"errorUsers"}/>
                                <div style={{ ...style.errorCounts }}>
                                    {Object.entries(errorCounts).map((error, idx) => {
                                        let [type, count] = error                                    
                                        return (
                                            <span key={idx.toString()}>{`${type}:  ${count}`}</span>
                                            )
                                        })}
                                </div>
                            </div>}

                        {showSuccessUsersList && 
                            <div style={{ marginTop: '30px' }}>
                                <h6>הוקמו:</h6>
                                <List users={this.state.successUsers} type={"successUsers"}/>
                                <div style={{ height: '100px' }}></div>
                            </div>}

                    </div>
                    
                </Layout.Content>
            </Layout>
        )
    }
}

const style = {
    topRow: { width: '100%', display: 'flex', alignItems: 'end', justifyContent: 'space-between' },
    secondRow: { height: '60px', marginTop: '20px' },
    form: {  },
    searchAgent: {
        display: 'flex',
        alignItems: 'end'
    },
    spinner: { display: 'flex', justifyContent: 'center', marginTop: '50px' },
    errorCounts: {
        display: 'flex',
        flexDirection: 'column',
        direction: 'ltr',
        textAlign: 'left'
    }
}